var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5893 6.07745C15.9148 6.40289 15.9148 6.93053 15.5893 7.25596L8.92267 13.9226C8.59723 14.2481 8.0696 14.2481 7.74416 13.9226L4.41083 10.5893C4.08539 10.2639 4.08539 9.73622 4.41083 9.41079C4.73626 9.08535 5.2639 9.08535 5.58934 9.41079L8.33341 12.1549L14.4108 6.07745C14.7363 5.75201 15.2639 5.75201 15.5893 6.07745Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.50ec1f3cc45e6b4492dbf09fe3767ba6.svg";
export { ForwardRef as ReactComponent };